import { fetchApiData, interpolate } from '../../Utils/ApiCalls';
import { LIST_CREATE_QUALIFY_OPS_ESTIMATORS_ENDPOINT, UPDATE_QUALIFY_OPS_ESTIMATOR_ENDPOINT } from '../../urls';
import { normalizeCompanies } from '../SharedComponent/CompanyPicker/api';

export const isEstimatorActive = item => item?.is_qualify_ops === true;

export const estimatorName = item => (item?.full_name || '').trim() || '—';

export const companiesLabel = companies => {
  const names = (companies || []).map(company => company?.name).filter(Boolean);
  if (!names.length) return '–';
  if (names.length <= 2) return names.join(', ');
  return `${names[0]}, ${names[1]} +${names.length - 2}`;
};

export const ESTIMATORS_PER_PAGE = 20;

export const estimatorsCount = data => {
  if (Array.isArray(data)) return data.length;
  const count = Number(data?.count);
  return Number.isFinite(count) ? count : parseEstimators(data).length;
};

export const parseEstimators = data => {
  const raw = Array.isArray(data) ? data : data?.results || [];
  return raw.map(item => ({
    id: item?.id,
    fullName: estimatorName(item),
    email: item?.email || '',
    companies: normalizeCompanies(item?.assigned_companies || []),
    isActive: isEstimatorActive(item),
    raw: item
  }));
};

export const listSniperEstimators = ({ q, page = 1, perPage = ESTIMATORS_PER_PAGE, signal } = {}) =>
  fetchApiData({
    endpoint: LIST_CREATE_QUALIFY_OPS_ESTIMATORS_ENDPOINT,
    apiRequest: 'GET',
    params: {
      page,
      per_page: perPage,
      ...(q ? { q } : {})
    },
    signal
  });

export const createSniperEstimator = ({ email, companyIds }) =>
  fetchApiData({
    endpoint: LIST_CREATE_QUALIFY_OPS_ESTIMATORS_ENDPOINT,
    apiRequest: 'POST',
    data: {
      email,
      assigned_companies: companyIds
    }
  });

export const companiesFromUpdate = data => {
  if (Array.isArray(data)) return normalizeCompanies(data);
  if (Array.isArray(data?.assigned_companies)) return normalizeCompanies(data.assigned_companies);
  if (Array.isArray(data?.results)) return normalizeCompanies(data.results);
  return null;
};

export const updateSniperEstimator = ({ userId, companyIds, isQualifyOps }) =>
  fetchApiData({
    endpoint: interpolate(UPDATE_QUALIFY_OPS_ESTIMATOR_ENDPOINT, [encodeURIComponent(userId)]),
    apiRequest: 'PATCH',
    data: {
      ...(Array.isArray(companyIds) ? { assigned_companies: companyIds } : {}),
      ...(typeof isQualifyOps === 'boolean' ? { is_qualify_ops: isQualifyOps } : {})
    }
  });
